import { render, staticRenderFns } from "./PlayGeoQuiz.vue?vue&type=template&id=64c42178&scoped=true&"
import script from "./PlayGeoQuiz.vue?vue&type=script&lang=js&"
export * from "./PlayGeoQuiz.vue?vue&type=script&lang=js&"
import style0 from "./PlayGeoQuiz.vue?vue&type=style&index=0&id=64c42178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c42178",
  null
  
)

export default component.exports